<template>
	<div class="tx">
		<header>
			<h1>
				<router-link to="/mine/tixian">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">银行卡</p>
			</h1>
		</header>
		<div class="txa">
			<div class="card" v-for="itm in bank">
				<div v-on:click="tixian(itm.bank_id)" class="bank_href">
					<p class="carda">{{itm.bank_name}}</p>
					<p class="cardb">储蓄卡</p>
					<p class="cardc">{{itm.bank_number}}</p>
				</div>	
				<div class="cardd" v-on:click="add(itm.bank_id)">x</div>
			</div>
		</div>
		<div class="addcard">
			<router-link to="/mine/addcard">
				<p class="addcardc">添加银行卡</p>
			</router-link>
		</div>
		<div class="popup">
			<div class="pop">
				<p class="potps">提示</p>
				<p class="ponav">是否删除银行卡</p>
				<button class="cancel" v-on:click="cancel()">取消</button>
				<button class="confirm" v-on:click="confirm()">确认</button>
			</div>
		</div>
		
	</div>
</template>
<script>
import appNav from "../common/appNav";
import { CURL } from "../../lib/url.js";
import $ from 'jquery';
export default {
  components: {
    appNav
  },
  data() {
    return {
    	bank:[],
    	_bank:[],
    }
  },
  mounted() {
    this.getAjax();
  },
  methods:{
  	tixian:function(id){
//		location.href = '/mine/tixian/?id='+id;
  		this.$router.push({path:'/mine/tixian/?id='+id})
  	},
  	cancel:function(){
  		$('.popup').fadeOut()
  	},
  	confirm:function(){
  		var _bankid = this._bank
  		var openid=localStorage.getItem("openid");
        $.get(CURL+"/portal/All/getdelebank",{"_bankid":_bankid,"openid":openid},function(data){
            console.log(data.delete_num);//获取ajax请求参数
            window.location.reload();
        });
  	},
  	add:function(e){
  		this._bank=e
  		$('.popup').fadeIn()
  	},
	getAjax:function () {
	var successCallback =  (response) => {
	  console.log('success')
	  this.bank = response.bank
	}
	var errorCallback =  (response) => {
	    console.log('error')
	}
	var openid=localStorage.getItem("openid");
	this.$http.get(CURL+'/portal/All/getbank?openid='+openid).then(successCallback,errorCallback);
	}
	}
};

</script>
<style lang="scss" scoped>
.bank_href{
	width: 80%;
}
.cancel,.confirm{
	width: 43%;
	padding: 7px 0 7px 0;
	background-color: inherit;
	border: #FFFFFF solid 1px;
	color: #FFFFFF;
	border-radius: 3px;
}
.confirm{
	margin: 3px 4% 7px 0;
}
.cancel{
	margin: 3px 4% 7px 4%;
}
.ponav{
	padding: 5px 0 15px 10px;
	font-size: 13px;
	font-weight: 550;
	color: #eee;
	text-align: center;
}
.potps{
	font-size: 16px;
	font-weight: 550;
	color: #eee;
	padding: 10px 0 10px 10px;
}
.popup{
	display: none;
	position: fixed;
	width: 100%;
	height: 100%;
	background:rgba(0,0,0,0.7);
}
.pop{
	margin-top: 50%;
	margin-left: 20%;
	width: 60%;
	background-color: #00a8d9;
	border-radius: 3px;
}
/*txa*/
.addcardc{
	color:  #00a8d9;
}
.addcard{
	margin-top: 20px;
	float: left;
	width: 100%;
	padding: 15px 0 15px 20px;
}
.cardd{
	position: relative;
	width: 20px;
	height: 20px;
	border: #FFFFFF solid 1px;
	border-radius: 50%;
	text-align: center;
	line-height: 15px;
	top: -79px;
	left: 92%;
	color: #FFFFFF;
}
.cardc{
	margin-top: 10px;
}
.carda,.cardb,.cardc{
	height: 20px;
	color: #FFFFFF;
	width: 60%;
	overflow: hidden;
}
.card{
	padding: 15px 0 15px 20px;
	background-color: #22b4de;
	width: 96%;
	margin: 0 2% 0 2%;
	float: left;
	height: 100px;
	border-radius: 5px;
	margin-bottom: 10px;
}
.txa{
	margin-top: .5rem;
	float: left;
	width: 100%;
}
/*head*/
header{
    position: fixed;
    height: .4rem;
    background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
    float: left;
    width: 100%;
    z-index: 99999999;
}
.set_1{
    text-align: center;
    float: left;
    width: 80%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height: .4rem;
}
.set_2{
    float: left;
    margin-left: 3%;
    margin-top:12px;
    width: 5%;
    color: #FFFFFF;
}
.tx{
	width: 100%;
	background-color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/card.vue